module.exports = require('./dizhi.json')